import { useCallback, useEffect } from "react";

import { MATCH_TYPE } from "../utils/const";
import { makeSearchRegExp } from "../utils/searchTerm";
import { getGroupIndex } from "../utils/navigation";
import { scrollToMatch, findActiveMatchDOM } from "../utils/dom";

export const useMatchFocus = ({
  inputValue,
  currentSectionIndex,
  activeSectionIndex,
  activeMatchIndex,
  matches,
  handleOpenTable,
  highlightSectionMatches,
  openSectionByIndex,
  setActiveSectionIndex,
}) => {
  const focusFirstMatch = useCallback(
    ({ newMatches, searchRegExp, activeMatchIndex }) => {
      const newSectionIndex = newMatches.findIndex(
        (section) => section.length > 0
      );

      if (newSectionIndex === currentSectionIndex) {
        const activeGroupIndex = 0;
        const activeGroup = newMatches[newSectionIndex][activeGroupIndex];
        if (activeGroup?.type === MATCH_TYPE.TABLE) {
          handleOpenTable({
            tableId: activeGroup.meta.tableId,
            searchRegExp,
            matches: newMatches,
            activeMatchIndex,
            activeGroupIndex,
            activeSectionIndex: currentSectionIndex,
          });
        }
        if (activeGroup?.type === MATCH_TYPE.SECTION) {
          scrollToMatch(findActiveMatchDOM());
        }

        return;
      }
      if (newSectionIndex > -1) {
        setActiveSectionIndex(newSectionIndex);
        openSectionByIndex(newSectionIndex);
      }
    },
    [
      currentSectionIndex,
      handleOpenTable,
      openSectionByIndex,
      setActiveSectionIndex,
    ]
  );

  const handleSectionChange = async () => {
    const searchRegExp = makeSearchRegExp(inputValue);
    if (!searchRegExp) {
      return;
    }

    await new Promise((resolve) => setTimeout(resolve, 0));

    const currentMatchToHighlight =
      activeSectionIndex === currentSectionIndex ? activeMatchIndex : -1;

    const activeSection = matches[activeSectionIndex];
    const activeGroupIndex = getGroupIndex(activeSection, activeMatchIndex);
    const activeGroup = activeSection[activeGroupIndex];

    highlightSectionMatches(searchRegExp, currentMatchToHighlight);

    if (activeGroup?.type === MATCH_TYPE.TABLE) {
      handleOpenTable({
        tableId: activeGroup.meta.tableId,
        searchRegExp,
        matches,
        activeSectionIndex,
        activeGroupIndex,
        activeMatchIndex,
      });
    }
    if (activeGroup?.type === MATCH_TYPE.SECTION) {
      scrollToMatch(findActiveMatchDOM());
    }
  };

  useEffect(
    () => {
      handleSectionChange();
    },
    [currentSectionIndex] // eslint-disable-line react-hooks/exhaustive-deps
  );

  return { focusFirstMatch };
};
